import { useEffect, useState } from "react";

const CountDown = ({finishHandler}:{finishHandler:Function}) => {
	const initialMinutes:number = 2;
	const initialSeconds:number = 0;

	const [minutes, setMinutes] = useState<number>(initialMinutes);
	const [seconds, setSeconds] = useState<number>(initialSeconds);

	useEffect(() =>{
		let myInterval:ReturnType<typeof setTimeout> = setTimeout(()=> {
			if (seconds > 0) {
				setSeconds(seconds - 1);
			}
			if (seconds === 0) {
				if (minutes === 0) {
					clearInterval(myInterval);
					finishHandler();
				}
				else{
					setMinutes(minutes - 1);
					setSeconds(59);
				}
			}
			
		}, 1000)
		return ()=>{
			//clearInterval(myInterval);
		}
	});

	return (
		<>
			<div style={{textAlign:'center'}}>
				<h1>
					{minutes} : {seconds < 10 ? `0${seconds}` : seconds}
				</h1>
			</div>
		</>
	)
}

export default CountDown;